import React from 'react';
import { Card, Alert, Empty } from 'antd';

interface ProjectApprovalStepProps {
  module: string | null;
  projectCode: string;
}

const ProjectApprovalStep: React.FC<ProjectApprovalStepProps> = ({
  module,
  projectCode,
}) => {
  if (!module) {
    return (
      <Alert
        message="请选择要操作的项目立项模块"
        description="请从左侧导航中选择具体的立项模块"
        type="info"
        showIcon
      />
    );
  }

  return (
    <Card title={`项目立项 - ${module}`}>
      <Alert
        message="暂无内容"
        description={`模块 "${module}" 暂无可用内容`}
        type="info"
        showIcon
      />
    </Card>
  );
};

export default ProjectApprovalStep;
